import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/api/client'

/**
 * Current OAuth-authenticated user, or null if signed out.
 *
 * Cached for 60s — the user object doesn't change mid-session, and we don't
 * want a /api/me request on every Navbar re-render. Window focus refetch
 * catches the "signed out in another tab" case.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: authApi.me,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}
